import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import { XS } from "constants/sizes";
import Testimonial from "segments/desktop/core-components/testimonial/testimonial";
import FullWithBulletsParagraphComponent from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-component";
import { StyledSideBySideTabsAndTestimonialTabsComponent } from "./side-by-side-tabs-and-testimonial-tabs-component.scss";
import DefaultProps, { TAB_CONTENT_DEFAULT_PROPS } from "./default-props";

const SideBySideTabsAndTestimonialTabsComponent = ({
  tabContent,
  title,
  advancedTitleConfig,
  prerenderTabs,
  ...rest
}) => {
  const contentRenderer = (contentObject) => (
    <div className="tab-content">
      <FullWithBulletsParagraphComponent
        {...TAB_CONTENT_DEFAULT_PROPS}
        {...contentObject}
        bulletsConfig={contentObject?.bulletsConfig?.bullets?.length ? contentObject.bulletsConfig : null}
        {...tabContent}
        titleSize={XS}
      />
    </div>
  );
  const testimonialRenderer = ({ testimonial }) => <Testimonial {...testimonial} />;

  return (
    <StyledSideBySideTabsAndTestimonialTabsComponent className="side-by-side-tabs-and-testimonial-tabs-component">
      <VerticalTimerTabs
        {...rest}
        prerenderTabs={prerenderTabs}
        title={{ ...title, ...advancedTitleConfig }}
        tabContentRenderer={contentRenderer}
        rightSideRenderer={testimonialRenderer}
      />
    </StyledSideBySideTabsAndTestimonialTabsComponent>
  );
};

SideBySideTabsAndTestimonialTabsComponent.defaultProps = DefaultProps;

export default SideBySideTabsAndTestimonialTabsComponent;
